/**
 * Created by koqiui on 2017-04-09.
 */
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues';
//
import bizMsgApi from '../../api/bizMsg'
//
import SwbMsgSubscrDlg from '../bizMsg/MsgSubscrDlg';
Vue.regist(SwbMsgSubscrDlg);

import SwbBizEventMsgSubscrList from './SubscrList';
Vue.regist(SwbBizEventMsgSubscrList);

/**
 * 消息订阅
 * @param staffId
 * @param eventMsgId
 */
export function openMsgSubscrDlg(staffId, eventMsgId, topicId) {
    let theDlg = Vue.$showDialog({
        title: '消息订阅',
        showCloseBtn: true,
        width: 1000,
        height: 600,
        okText: '保存',
        cancelText: '关闭',
        template: '<swb-msg-subscr-dlg :staffId="staffId" :eventMsgId="eventMsgId" ref="swb_msg_subscr_dlg"></swb-msg-subscr-dlg>',
        data: {
            staffId: staffId,
            eventMsgId: eventMsgId
        },
        okClicked: function () {
            let result = this.$refs.swb_msg_subscr_dlg.getDlgResult() || {};
            if(result.type == 'info') {
                let resultData = result.data;
                if(Utils.isNoB(resultData.saveFlag)) {
                    resultData.topicId = topicId;
                    //
                    let theLoad = MsgBox.loading();
                    bizMsgApi.saveBizEventMsgSubscrs(resultData, function (result) {
                        theLoad.hide();
                        if(result.type == 'info') {
                            // theDlg.close();
                            MsgBox.success('操作成功！');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    // Toast.show("未修改信息！");
                    MsgBox.success('操作成功！');
                }
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

export function showEventMsgSubscrListDlg(staffId, eventMsgId, callback) {
    eventMsgId = eventMsgId || null;
    Vue.$showDialog({
        title: "已订阅消息列表 - 查看",
        width: 900,
        height: 700,
        showCloseBtn: false,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-biz-event-msg-subscr-list :staffId="staffId" :eventMsgId="eventMsgId" ref="swb_biz_event_msg_subscr_list"></swb-biz-event-msg-subscr-list>',
        data: {
            staffId: staffId,
            eventMsgId: eventMsgId
        },
        okClicked: function () {
        },
        cancelClicked: function () {
            callback();
        },
        methods: {}
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/bizMsg/dialog.js
// module id = 223
// module chunks = 0